import { MessageCircle } from "lucide-react";
import { COMPANY } from "../data/site";

export const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${COMPANY.whatsapp}?text=Hello%20RNS%20Automobiles%2C%20I%20would%20like%20to%20enquire%20about%20a%20spare%20part.`}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg wa-pulse hover:scale-105 transition-transform duration-200"
  >
    <MessageCircle className="h-6 w-6" />
  </a>
);
